<template>
  <div class="payment-info">
    <ul>
      <li>
        <div class="label">商品订单:</div>
        <div class="value">{{orderData.orderNo | noText}}</div>
      </li>
      <li>
        <div class="label">支付金额:</div>
        <div class="value" v-if="orderData.payAmount !== undefined"><span>¥</span>{{orderData.payAmount | formatMoney}}</div>
        <div class="value" v-else>---</div>
      </li>
    </ul>
    <div class="expansion">
      <div class="box" @click="isExpansion = !isExpansion" >
        订单详情
        <i class="el-icon-arrow-down" v-if="!isExpansion"></i>
        <i class="el-icon-arrow-up" v-else></i>
      </div>
      <div class="ul" :class="isExpansion ? 'show' : 'hidden'">
        <div class="li">
          <div class="label">商品名称:</div>
          <div class="value">{{orderData.productName | noText}}</div>
        </div>
        <div class="li">
          <div class="label">支付订单:</div>
          <div class="value">{{orderData.paymentNo | noText}}</div>
        </div>
        <div class="li">
          <div class="label">应付金额:</div>
          <div class="value" v-if="orderData.payAmount !== undefined">￥{{orderData.payAmount | formatMoney}}</div>
          <div class="value" v-else>---</div>
        </div>
        <div class="li">
          <div class="label">购买时间:</div>
          <div class="value">{{orderData.createTime | format('YYYY年MM月DD日')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderData: {
      default: () => ({})
    }
  },
  data() {
    return {
      isExpansion: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.payment-info {
  width: 100%;
  width: 330px;
  margin: 0 auto;
  padding-bottom: 24px;
  > ul {
    li {
      display: flex;
      align-items: center;
      .label {
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #16181a;
      }
      .value {
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #4f5d78;
        margin-left: 16px;
        height: 20px;
        line-height: 20px;
      }
      &:last-child {
        margin-top: 16px;
        .value {
          color: #ef2a2aff;
          font-size: 20px;
          font-weight: bold;
          line-height: 0;
          height: 22px;
          line-height: 22px;
          span {
            font-size: 12px;
          }
        }
      }
    }
  }
  .expansion {
    margin-top: 16px;
    .box {
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #4f5d78;
      margin-bottom: 16px;
      cursor: pointer;
    }
    .ul {
      height: 0;
      overflow: hidden;
      transition: 1s;
      .li {
        display: flex;
        margin-bottom: 16px;
        .label {
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #4f5d78;
          margin-right: 17px;
          height: 14px;
          line-height: 14px;
        }
        .value {
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #4f5d78;
          height: 14px;
          line-height: 14px;
        }
      }
    }
    .show {
      height: auto;
    }
  }
}
</style>
